<template>
    <!-- 登录 by Calvin -->
    <div class="login-new">
            <!-- 头部 -->
            <div class="log-container">
                <div class="log-row account-row">
                    <input
                        type="text"
                        class="newInput"
                        placeholder="账号"
                        v-model="accountNumber"
                        autofocus
                        @blur="accountBlur"
                    >
                    <span class="icon icon-act"></span>
                </div>
                <div class="log-row password-row">
                    <input
                        type="password"
                        class="newInput"
                        placeholder="密码"
                        v-model="password"
                        @blur="passwordBlur"
                    />
                    <span class="icon icon-psw"></span>
                    <div class="back-psw" @click="showForgetPsw">忘记?</div>
                </div>


                <!--验证码-->
                <div v-if="type === 0" class="log-row code-row marginStyle">
                    <input
                        type="text"
                        class="newInput"
                        :placeholder="$t('loginPage.verifyCodeP')"
                        v-model="captchaCode"
                        @blur="captchaCode = toCDB(captchaCode)"
                        @keyup.enter="login"
                    />
                    <div
                        class="verifyCodeImg"
                        v-if="verifyCodeImg"
                        @click="captchaData"
                        :style="'background-image:url(' + verifyCodeImg + ')'"
                    ></div>
                    <div class="verifyCodeImg getCode u-flex-all" v-if="!verifyCodeImg">
                        <img loading="lazy" v-lazy="require('../../assets/images/qiqi/refresh.png')" class="refimg" alt />
                        {{ $t("loginPage.regain") }}
                    </div>
                </div>

                <!-- 行为校验  树莓 -->
                <div
                    v-show="type === 2"
                    id="captcha"
                    class="captchaStyle"
                    @click="captchaClick"
                >{{ captchaText }}</div>

                <!--  行为验证 极验 -->
                <div v-show="type === 1" id="captcha1" class="marginStyle"></div>
                <!--  行为验证 极验4 -->
                <div v-show="type === 3" id="gt4" class="marginStyle"></div>
                <!-- getDefaultStatus接口请求失败 -->
                <div
                    class="marginStyle getCode u-flex-all cursorPoint"
                    v-if="errorCode"
                    @click="getDefaultStatus"
                >
                    <img loading="lazy" v-lazy="require('../../assets/images/qiqi/refresh.png')" class="refimg" />
                    {{ $t("loginPage.regain") }}
                </div>

                <div class="log-bottom">
                    <div class="bottom-btn submit-btn-new" @click="login">登入</div>
                    <div class="bottom-btn btn-register" @click="toRegister">免费开户</div>
                </div>
            </div>
             <!-- 改版提示 -->
            <div class="updateTips" v-if="loginJson && loginJson.title">
                <span class="themeTextColor">{{ loginJson.title }}：</span>
                {{ loginJson.content }}
            </div>
        <forgetPsw ref="forgetPsw"></forgetPsw>
        <validateLogin ref="validateLogin" @login="login" :accountNumber="accountNumber"></validateLogin>
        <el-dialog
            :visible.sync="deviceVisible"
            width="600px"
            :append-to-body="true"
            :show-close="true"
        >
            <ValidateDevice :account="accountNumber" @login="deviceVisible = false,login()"></ValidateDevice>
        </el-dialog>    
    </div>
</template>

<script>
import MyAes from "../../utils/myAes.js";
import store from "../../store/store";
import forgetPsw from "@/components/forgetPsw/forgetPsw";
import validateLogin from "@/components/validateLogin/validateLogin";
import ValidateDevice from "./ValidateDevice";
import {_getDeviceId} from '@/utils/finger'
import "../../utils/smcp.min.js";
import "../../utils/boc"
export default {
    name: "login",
    data() {
        return {
            show: false,
            captchaCode: "",
            captchaKey: "",
            isShowClose: false,
            accountNumber: "",
            password: "",
            verifyCodeImg: "--",
            isClickLogin: true, //只有第一次登录生效，除非登录失败
            window: window,
            dataList: null,
            loginJson: null,
            type: 1, //行为校验2
            captcha: null, //行为校验
            captchaBox: null,
            captchaText: "",
            captchaMask: false,
            errorCode: false,
            validateStatus: -1, //默认Login异常
            // 数美请求参数
            smData: {
                lang: '',
                mode: '',
                organization: '',
                product: '',
                appId: '',
                channel: '',
            },
            deviceVisible:false,
            fingerprintState: false
        };
    },
    mounted() {
        this.loginSet();
        this.getDefaultStatus();
    },
    methods: {
        // 获取   getDefaultStatus
        getDefaultStatus() {
            let _this = this;
            this.$http.get(this.$api.getDefaultStatus, false).then(res => {
                if (res.code == 0) {
                    // type   0：默认验证码  1：极验  2：数美"
                    _this.type = res.data.type;
                    // _this.type = 1;
                    if (_this.type === 0) {
                        //图片验证码
                        //获取验证码图片
                        this.captchaData();
                    } else if (_this.type === 1 || _this.type === 3) {
                        //1：极验
                        _this.reset();
                    } else if (_this.type === 2) {
                        //2：数美"
                        Object.assign(_this.smData, res.data);
                        _this.reset();
                    }
                    _this.fingerprintState = res.data.fingerprintState
                    if(res.data.fingerprintState) {
                      _getDeviceId(res.data.fingerprintId).then( res => {
                        _this.$config.fingerprint = res
                        sessionStorage.setItem('fingerprint', res);
                      })
                    }
                } else {
                    this.errorCode = true;
                    this.type = null;
                    this.moneyModeListReqSuccess = false;
                    this.$message.error(this.$t("loginPage.loadFail"));
                }
            });
        },
        //行为校验↓
        reset() {
            this.check();
            this.getCaptcha();
        },
        check() {
            if(this.type === 3){
                this.captcha && this.captcha.reset()
            } else {
                if (this.captcha) {
                    this.captchaText = "";
                } else {
                    this.captchaText = this.$t("loginPage.loading");
                }
            }
        },
        getCaptcha() {
            let lang = "zh";
            if (this.$config.local == "en_US") {
                lang = "en";
            } else if (this.$config.local == "zh_CN") {
                lang = "zh-cn";
            } else if (this.$config.local == "zh_HK") {
                lang = "zh-hk";
            }
            if (this.type == 1) {
                let _this = this;
                this.$http
                    .get(
                        this.$api.geetFirstRegister,
                        "?t=" + window.childCode,
                        false
                    )
                    .then(res => {
                        if (res.code == 0) {
                            window.initGeetest(
                                {
                                    gt: res.data.gt,
                                    challenge: res.data.challenge,
                                    new_captcha: res.data.newCaptcha, // 用于宕机时表示是新验证码的宕机
                                    offline: res.data.success !== 1, // 表示用户后台检测极验服务器是否宕机，一般不需要关注
                                    product: "float", // 产品形式，包括：float，popup
                                    width: "100%",
                                    lang: lang
                                },
                                _this.onCaptcha
                            );
                        } else {
                            this.$message.error(this.$t("loginPage.getError"));
                        }
                    });
            } else if (this.type == 2) {
                let data = {
                    ...this.smData,
                    width: 300,
                    https: location.protocol == "https:"
                };
                initSMCaptcha(
                    data,
                    this.onCaptcha
                );
            } else if(this.type === 3){
                if (!this.captcha) {
                    initBotion({
                    captchaId: this.$config.captchaId,
                    product: 'popup',//float  popup
                    language: lang,
                    nativeButton:{
                        width: '2rem',
                        height: '0.35rem'
                    }
                    }, this.onCaptcha);
                }
            }
        },
        onCaptcha(res) {
            //res是验证实例，可以调用res的示例方法
            var _this = this;
            this.captcha = res;
            if (_this.type == 1) {
                res.appendTo("#captcha1");
                res.onReady(_this.check);
            } else if (this.type == 2) {
                this.captchaText = _this.$t("loginPage.clickBtnToVerify");
                this.captcha.onSuccess(function(data) {
                    if (data.pass) {
                        _this.captcha.rid = data.rid;
                        _this.captchaText = _this.$t("loginPage.verifySuccess");
                        _this.captchaMask = false;
                    } else {
                        _this.captcha.rid = null;
                        _this.captchaText = _this.$t("loginPage.verifyFail");
                    }
                });

                this.captcha.onError(function() {
                    _this.captcha.rid = null;
                    _this.captchaText = _this.$t("loginPage.verifyFail");
                    _this.captchaMask = false;
                });

                this.captcha.onClose(function() {
                    _this.captchaMask = false;
                });
            } else if(this.type === 3){
                res.appendTo("#gt4");
            }
        },
        captchaClick() {
            if (this.type == 2) {
                var result = this.captcha.getResult();
                var pass = result.pass;
                if (!pass) {
                    this.captcha.verify();
                    //行为验证bug:点击关闭按钮，会点击穿透
                    //解决：手动再添加一个遮罩层
                    this.captchaMask = true;
                }
            }
        },
        //
        async loginSet() {
            var _this = this;
            var key = "member_login_tip";
            let res = await this.$http.get(this.$api.getRegisterSet, key);
            if (res.code == 0) {
                _this.loginJson = res.data.svalue;
            }
        },
        captchaData: async function(type) {
            let _this = this;
            const res = await this.$http.get(_this.$api.captcha);
            if (res.code == 0) {
                _this.verifyCodeImg = res.data.captcha_image_content;
                _this.captchaKey = res.data.captchaKey;
            } else {
            }
        },
        login: async function() {
            let captcha1 = document.querySelector("#captcha1");
            //登录接口
            var aseKey = "pigxpigxpigxpigx"; //秘钥
            // Encrypt 加密
            let encodePassword = MyAes.encrypt(this.password, aseKey);
            // Decrypt 解密
            // let decodePassword = MyAes.decrypt(encodePassword, aseKey);
            let _this = this;
            if (!this.accountNumber) {
                this.$message.error(_this.$t("loginPage.accountE"));
                return;
            } else if (!this.password) {
                this.$message.error(_this.$t("loginPage.passwordE"));
                return;
            } else if (this.type == 0 && !this.captchaCode) {
                this.$message.error(_this.$t("loginPage.verifyCodeE"));
                return;
            }

            if (this.type != 0) {
                var result = this.captcha.getValidate();

                if (!result) {
                    this.$message.error(_this.$t("loginPage.firstVerify"));
                    return;
                }
            }

            if (this.validateStatus === -1) {
                //登录异常验证
                this.validateLogin(encodePassword);
                return;
            }

            if (!this.isClickLogin) {
                return;
            }

            this.isClickLogin = false;

            let params = {
                name: this.accountNumber,
                password: encodePassword,
                lastLoginVersion: this.$config.loginVersion,
                validateType: this.type,
            };
            if(this.fingerprintState) {
              params.fingerprint = this.$config.fingerprint
              params.phoneModel = this.$config.phoneModel
            }

            //账号处理
            if (window.mergeAccount) {
                params.name = this.accountNumber + window.mergeAccount;
            }

            if (this.type === 1) {
                params.geeTestQueryVO = {
                    challenge: result.geetest_challenge,
                    seccode: result.geetest_seccode,
                    validate: result.geetest_validate
                };
            } else if (this.type === 2) {
                params.shuMeiQueryVO = {
                    rid: result.rid
                };
            } else if (this.type === 0) {
                params.captchaKey = this.captchaKey;
                params.captchaCode = this.captchaCode;
            } else if(this.type === 3){
                 params.geeTestQueryVO = result
            }
            const res = await _this.$http.post(_this.$api.login, params, true);
            if (res.code == 0) {
                if (res.data.firstLogin) {
                    _this.show = false;
                    _this.dataList = res.data;
                } else {
                    //登录成功提示
                    this.$message({
                        message: _this.$t("loginPage.loginSuccess"),
                        type: "success"
                    });
                    //第一次登录
                    sessionStorage.setItem("firstLogin", true);
                    store.commit("firstLogin", true);

                    _this.$common.setUser(res.data);
                    _this.$common.setToken(res.data);

                    //获取个人信息
                    this.$nkhttp.getUserInfo();
                    this.hideDialog();
                    store.commit("advertisingShow", 1);
                }
                this.$router.push({ path: "/my/info/basic" });
            } else {
                this.validateStatus = -1
                this.$common.clearToken();
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
                if (_this.type === 1) {
                    captcha1.innerHTML = "";
                }
                this.getDefaultStatus();
                this.isClickLogin = true;
            }
        },
        hideDialog() {
            //隐藏
            this.show = false;
        },
        notHideDialog() {},
        toCDB(str) {
            //全角转为半角
            var tmp = "";
            for (var i = 0; i < str.length; i++) {
                if (str.charCodeAt(i) == 12288) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 12256);
                }
                if (str.charCodeAt(i) > 65280 && str.charCodeAt(i) < 65375) {
                    tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
                } else {
                    tmp += String.fromCharCode(str.charCodeAt(i));
                }
            }
            return tmp;
        },
        accountBlur() {
            //   //大写转小写
            this.accountNumber = this.accountNumber.toLowerCase();
            //   //全角转半角
            //   this.accountNumber = this.toCDB(this.accountNumber);
            //   //空格处理
            // eslint-disable-next-line no-useless-escape
            this.accountNumber = this.accountNumber.replace(/\ /g, "");
        },
        passwordBlur() {
            //   //大写转小写
            //   this.password = this.password.toLowerCase();
            //   //全角转半角
            //   this.password = this.toCDB(this.password);
            //   //空格处理
            // eslint-disable-next-line no-useless-escape
            // this.password = this.password.replace(/\ /g, "");
        },
        // toCustomerService() {
        //     const url = this.$common.getCustomerService();
        //     window.open(url, "_blank");
        // },
        showForgetPsw() {
            var _this = this;
            _this.show = false;
            setTimeout(() => {
                _this.$refs.forgetPsw.openDialog();
            }, 1000);
        },
        toRegister() {
            this.show = false;
            this.$router.push("/register");
        },
        async validateLogin(encodePassword) {
            let captcha1 = document.querySelector("#captcha1");
            var _this = this;
            var params = {
                name: _this.accountNumber,
                password: encodePassword,
                fingerprint: this.$config.fingerprint
            };

            //账号处理
            if (window.mergeAccount) {
                params.name = this.accountNumber + window.mergeAccount;
            }
            const res = await _this.$http.post(
                _this.$api.validateLogin,
                params,
                true
            );
            if (res.code == 0) {
                _this.validateStatus = res.data.validateStatus ? 1 : 0;
                if (_this.validateStatus === 1) {
                    //无异常
                    _this.login();
                } else {
                    const {validateWay} = res.data ?? {}
                    if (validateWay === 'ip') this.$refs.validateLogin.openDialog();
                    if (validateWay === 'device') this.deviceVisible = true
                }
            } else {
                var msg =
                    _this.$t(`errorCode.${res.code}`) + `(${res.code})` ||
                    _this.$t("errorCode.webDefault");
                this.$http.errMsg(msg);
                if (_this.type === 1) {
                    captcha1.innerHTML = "";
                }
                this.getDefaultStatus();
            }
        }
    },
    watch: {
        show(n) {
            if (n) {
                //初始化数据
                this.captchaCode = "";
                this.captchaKey = "";
                this.accountNumber = "";
                this.password = "";
                this.validateStatus = -1;
            } else {
                let captcha1 = document.querySelector("#captcha1");
                captcha1 && captcha1.remove();
            }
        }
    },
    components: {
        forgetPsw,
        validateLogin,
        ValidateDevice
    }
};
</script>
<style lang="less" scoped>
.login-new {
    max-width: 920px;
    display: flex;
    flex-wrap: wrap;
    .log-container {
        display: flex;
        align-items: center;
        .log-row {
            display: flex;
            align-items: center;
            position: relative;
            height: 36px;
            position: relative;

            .newInput {
                box-sizing: border-box;
                width: 168px;
                height: 30px;
                line-height: 30px;
                border-radius: 5px;
                border: 1px solid #aa9b13;
                background-color: #000;
                color: #fff;
                margin-right: 8px;
                padding: 0 50px 0 25px;
                &::-webkit-input-placeholder {
                    color: #fff!important;
                }

                &::-moz-placeholder {
                    color: #fff!important;
                }

                &:-ms-input-placeholder {
                    color: #fff!important;
                }

                &::-ms-input-placeholder {
                    color: #fff!important;
                }

                &::placeholder {
                    color: #fff!important;
                }
            }
            .back-psw {
                cursor: pointer;
                position: absolute;
                height: 28px;
                line-height: 27px;
                border-left: 1px solid #aa9b13;
                right: 8px;
                padding: 0 10px;
                top: 4px;
                color: #fff;
                &:hover {
                    color: #fff383;
                }
            }
            .icon {
                position: absolute;
                width: 14px;
                height: 16px;
                left: 5px;
                top: 9px;
                background-size: 100%;
                &.icon-act {
                    background-image: url('../../assets/images/amjs/icon_register.png');
                }
                &.icon-psw {
                    background-image: url('../../assets/images/amjs/icon_psw.png');
                }
            }
        }
        .code-row {
            border: none;
            justify-content: space-between;
            .verifyCodeImg {
                width: 100px;
                height: 30px;
                border-radius: 3px;
                background: #ededed;
                background-size: 100% 100%;
                margin-left: 10px;
            }
        }
        .log-bottom {
            display: flex;
            .bottom-btn {
                width: 100px;
                height: 32px;
                line-height: 32px;
                border-radius: 5px;
                font-size: 15px;
                text-align: center;
                cursor: pointer;
                &.submit-btn-new {
                    margin: 0 10px;
                    color: #000;
                    background-color: #fdf884;
                    background-image: linear-gradient(to right, #d5ac55 , #fdf984, #d5ac55);
                }
                &.btn-register {
                    color: #fff;
                    background-color: #ab0000;
                    background-image: linear-gradient(#bc0000 , #a20000, #c40b0b);
                }
                &:hover {
                    filter: brightness(1.3);
                }
            }
        }
    }
    .updateTips {
        text-align: left;
        line-height: 24px;
        font-size: 14px;
        color: #ff3a2b;;
        .themeTextColor {
            color: #ff3a2b;
        }
    }

    #captcha1 {
        width: 150px;
        height: 32px;
        line-height: 32px;
        border-radius: 3px;
        background-color: #f9f9f9;
        /deep/.geetest_holder.geetest_wind {
            height: 32px !important;
            .geetest_radar_btn .geetest_radar {
                width: 20px !important;
                height: 20px !important;
                margin: 4px !important;
            }
            .geetest_radar_tip,.geetest_success_radar_tip {
                height: 30px !important;
                line-height: 30px !important;
                color: #313131 !important;
                text-align: center !important;
                font-size: 12px !important;
                padding: 0 22px !important;
            }
        }
    }
    .getCode {
        height: 32px;
        border-radius: 3px;
        background: #fff;
        border: 2px solid #f0f0f0;
        width: 100%;
        color: #313131;
        .refimg {
            width: 22px;
            vertical-align: middle;
        }
    }
}
</style>
